module.exports = {
  API: 'http://www.aistan.com.au/api',
  port: 3000
};



// WEBPACK FOOTER //
// ./src/lib/config/production.js